// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===========================================================
   Toast — compact editorial pill, landing-palette accent.
   Lives bottom-center, exits on close/click/5s auto-dismiss.
   =========================================================== */

.toast {
  position: fixed;
  z-index: 10000;
}

.toast-bottom-center {
  bottom: 1.75rem;
  left: 50%;
  transform: translateX(-50%);
}

.toast-bottom-left {
  bottom: 8rem;
  left: 2rem;
  transform: none;
}

/* Pill surface — thin, intentional, NOT a floating card block */
.toast-content {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 14px;
  padding: 9px 14px 9px 18px;
  min-width: 200px;
  max-width: 420px;

  color: #f3f4f6;
  background:
    linear-gradient(180deg, rgba(18, 18, 22, 0.94), rgba(10, 10, 12, 0.94));
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 999px;
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  box-shadow:
    0 14px 36px rgba(0, 0, 0, 0.55),
    0 1px 0 rgba(255, 255, 255, 0.04) inset;

  animation: toastSpringIn 360ms cubic-bezier(0.2, 0.9, 0.28, 1.15);
  overflow: hidden;
}

/* Leading dot — sky→violet gradient, acts as the semantic cue */
.toast-content::before {
  content: '';
  flex-shrink: 0;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: linear-gradient(135deg, #0ea5e9, #8b5cf6);
  box-shadow:
    0 0 0 2px rgba(14, 165, 233, 0.12),
    0 0 12px rgba(139, 92, 246, 0.25);
  margin-right: 2px;
  animation: toastDotPulse 1.8s ease-in-out infinite;
}

/* Auto-dismiss progress — hairline gradient shrinking across bottom */
.toast-content::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  height: 1.5px;
  width: 100%;
  background: linear-gradient(90deg, #0ea5e9, #8b5cf6);
  transform-origin: left;
  animation: toastProgress 5s linear forwards;
  border-radius: 0 0 999px 999px;
  opacity: 0.7;
}

.toast-message {
  margin: 0;
  flex: 1 1;
  color: #e5e7eb;
  font-size: 0.82rem;
  font-weight: 500;
  letter-spacing: 0.005em;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.toast-close {
  all: unset;
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  line-height: 1;
  color: rgba(255, 255, 255, 0.4);
  border-radius: 50%;
  cursor: pointer;
  transition: color 120ms ease, background 120ms ease;
}

.toast-close:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.08);
}

.toast-close:focus-visible {
  outline: 1px solid rgba(14, 165, 233, 0.5);
  outline-offset: 2px;
}

@keyframes toastSpringIn {
  0% {
    opacity: 0;
    transform: translate(-50%, 14px) scale(0.96);
  }
  60% {
    opacity: 1;
    transform: translate(-50%, -3px) scale(1.01);
  }
  100% {
    opacity: 1;
    transform: translate(-50%, 0) scale(1);
  }
}

@keyframes toastProgress {
  from { transform: scaleX(1); }
  to   { transform: scaleX(0); }
}

@keyframes toastDotPulse {
  0%, 100% { opacity: 1;   transform: scale(1); }
  50%      { opacity: 0.65; transform: scale(1.15); }
}

/* bottom-left variant uses non-centered transform */
.toast-bottom-left .toast-content {
  animation: toastSlideInLeft 320ms cubic-bezier(0.2, 0.9, 0.28, 1.15);
}

@keyframes toastSlideInLeft {
  0% {
    opacity: 0;
    transform: translateX(-16px) scale(0.96);
  }
  100% {
    opacity: 1;
    transform: translateX(0) scale(1);
  }
}

/* Subtle reduced-motion path */
@media (prefers-reduced-motion: reduce) {
  .toast-content,
  .toast-bottom-left .toast-content {
    animation: none;
  }
  .toast-content::before { animation: none; }
  .toast-content::after  { animation: none; transform: scaleX(0); opacity: 0; }
}
`, "",{"version":3,"sources":["webpack://./src/components/Toast.css"],"names":[],"mappings":"AAAA;;;gEAGgE;;AAEhE;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;;AAEA,gEAAgE;AAChE;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;;EAEhB,cAAc;EACd;2EACyE;EACzE,2CAA2C;EAC3C,oBAAoB;EACpB,2BAA2B;EAC3B,mCAAmC;EACnC;;2CAEyC;;EAEzC,iEAAiE;EACjE,gBAAgB;AAClB;;AAEA,gEAAgE;AAChE;EACE,WAAW;EACX,cAAc;EACd,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qDAAqD;EACrD;;qCAEmC;EACnC,iBAAiB;EACjB,kDAAkD;AACpD;;AAEA,sEAAsE;AACtE;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,aAAa;EACb,WAAW;EACX,oDAAoD;EACpD,sBAAsB;EACtB,2CAA2C;EAC3C,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,SAAS;EACT,SAAO;EACP,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,4CAA4C;EAC9C;EACA;IACE,UAAU;IACV,4CAA4C;EAC9C;EACA;IACE,UAAU;IACV,sCAAsC;EACxC;AACF;;AAEA;EACE,OAAO,oBAAoB,EAAE;EAC7B,OAAO,oBAAoB,EAAE;AAC/B;;AAEA;EACE,WAAW,UAAU,IAAI,mBAAmB,EAAE;EAC9C,WAAW,aAAa,EAAE,sBAAsB,EAAE;AACpD;;AAEA,oDAAoD;AACpD;EACE,oEAAoE;AACtE;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,+BAA+B;AAC/B;EACE;;IAEE,eAAe;EACjB;EACA,yBAAyB,eAAe,EAAE;EAC1C,yBAAyB,eAAe,EAAE,oBAAoB,EAAE,UAAU,EAAE;AAC9E","sourcesContent":["/* ===========================================================\n   Toast — compact editorial pill, landing-palette accent.\n   Lives bottom-center, exits on close/click/5s auto-dismiss.\n   =========================================================== */\n\n.toast {\n  position: fixed;\n  z-index: 10000;\n}\n\n.toast-bottom-center {\n  bottom: 1.75rem;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.toast-bottom-left {\n  bottom: 8rem;\n  left: 2rem;\n  transform: none;\n}\n\n/* Pill surface — thin, intentional, NOT a floating card block */\n.toast-content {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  gap: 14px;\n  padding: 9px 14px 9px 18px;\n  min-width: 200px;\n  max-width: 420px;\n\n  color: #f3f4f6;\n  background:\n    linear-gradient(180deg, rgba(18, 18, 22, 0.94), rgba(10, 10, 12, 0.94));\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 999px;\n  backdrop-filter: blur(14px);\n  -webkit-backdrop-filter: blur(14px);\n  box-shadow:\n    0 14px 36px rgba(0, 0, 0, 0.55),\n    0 1px 0 rgba(255, 255, 255, 0.04) inset;\n\n  animation: toastSpringIn 360ms cubic-bezier(0.2, 0.9, 0.28, 1.15);\n  overflow: hidden;\n}\n\n/* Leading dot — sky→violet gradient, acts as the semantic cue */\n.toast-content::before {\n  content: '';\n  flex-shrink: 0;\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #0ea5e9, #8b5cf6);\n  box-shadow:\n    0 0 0 2px rgba(14, 165, 233, 0.12),\n    0 0 12px rgba(139, 92, 246, 0.25);\n  margin-right: 2px;\n  animation: toastDotPulse 1.8s ease-in-out infinite;\n}\n\n/* Auto-dismiss progress — hairline gradient shrinking across bottom */\n.toast-content::after {\n  content: '';\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  height: 1.5px;\n  width: 100%;\n  background: linear-gradient(90deg, #0ea5e9, #8b5cf6);\n  transform-origin: left;\n  animation: toastProgress 5s linear forwards;\n  border-radius: 0 0 999px 999px;\n  opacity: 0.7;\n}\n\n.toast-message {\n  margin: 0;\n  flex: 1;\n  color: #e5e7eb;\n  font-size: 0.82rem;\n  font-weight: 500;\n  letter-spacing: 0.005em;\n  line-height: 1.3;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.toast-close {\n  all: unset;\n  flex-shrink: 0;\n  width: 20px;\n  height: 20px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 15px;\n  line-height: 1;\n  color: rgba(255, 255, 255, 0.4);\n  border-radius: 50%;\n  cursor: pointer;\n  transition: color 120ms ease, background 120ms ease;\n}\n\n.toast-close:hover {\n  color: #fff;\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.toast-close:focus-visible {\n  outline: 1px solid rgba(14, 165, 233, 0.5);\n  outline-offset: 2px;\n}\n\n@keyframes toastSpringIn {\n  0% {\n    opacity: 0;\n    transform: translate(-50%, 14px) scale(0.96);\n  }\n  60% {\n    opacity: 1;\n    transform: translate(-50%, -3px) scale(1.01);\n  }\n  100% {\n    opacity: 1;\n    transform: translate(-50%, 0) scale(1);\n  }\n}\n\n@keyframes toastProgress {\n  from { transform: scaleX(1); }\n  to   { transform: scaleX(0); }\n}\n\n@keyframes toastDotPulse {\n  0%, 100% { opacity: 1;   transform: scale(1); }\n  50%      { opacity: 0.65; transform: scale(1.15); }\n}\n\n/* bottom-left variant uses non-centered transform */\n.toast-bottom-left .toast-content {\n  animation: toastSlideInLeft 320ms cubic-bezier(0.2, 0.9, 0.28, 1.15);\n}\n\n@keyframes toastSlideInLeft {\n  0% {\n    opacity: 0;\n    transform: translateX(-16px) scale(0.96);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0) scale(1);\n  }\n}\n\n/* Subtle reduced-motion path */\n@media (prefers-reduced-motion: reduce) {\n  .toast-content,\n  .toast-bottom-left .toast-content {\n    animation: none;\n  }\n  .toast-content::before { animation: none; }\n  .toast-content::after  { animation: none; transform: scaleX(0); opacity: 0; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
